import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconConciergeBell",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.5 9a1.5 1.5 0 0 0-1.02-1.421A4.5 4.5 0 0 0 6.5 3.528V2.5H7a.5.5 0 0 0 0-1H5a.5.5 0 0 0 0 1h.5v1.028a4.5 4.5 0 0 0-3.98 4.051A1.5 1.5 0 0 0 .5 9v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9ZM2 8.5a.5.5 0 0 0-.5.5v.5h9V9a.5.5 0 0 0-.5-.5H2Zm6.475-2.975A3.5 3.5 0 0 0 2.535 7.5h6.93a3.5 3.5 0 0 0-.99-1.975Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function u(a, h, i, f, p, e) {
  return l(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--concierge-bell"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Concierge Bell",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const C = /* @__PURE__ */ o(s, [["render", u]]);
export {
  C as default
};
//# sourceMappingURL=concierge-bell.js.map
